package er.prateek.crossly.persistence

import er.prateek.crossly.ui.theme.PaletteId
import er.prateek.crossly.ui.theme.ThemeMode

data class ThemePreferences(
    val mode: ThemeMode = ThemeMode.SYSTEM,
    val paletteId: PaletteId = PaletteId.CLASSIC,
)

interface ThemeStore {
    fun load(): ThemePreferences
    fun save(preferences: ThemePreferences)
}
